module.exports = __webpack_public_path__ + "2fe600a99ffa65ec6359c939cd94de45.png";


//////////////////
// WEBPACK FOOTER
// ./web/images/team/team-member-bhaji.png
// module id = 651
// module chunks = 0